export class IkeDelayedTask {
	private timeoutId: number | ReturnType<typeof setTimeout> | null = null;

	private readonly func: () => void;
	/** Default amount of MS to wait */
	private readonly ms: number;
	/** The next time this function is scheduled to run */
	private nextTime: number | null = null;

	constructor(func: () => void, ms: number = 0) {
		this.func = func;
		this.ms = ms;
	}

	get isActive() {
		return this.timeoutId != null;
	}

	delay(ms: number = this.ms) {
		const nextTime = Date.now() + ms;
		// Don't re-make the timeout if the next timeout is within X ms
		if (this.isActive) {
			const diffTime = Math.abs(nextTime - (this.nextTime ?? 0));
			if (diffTime < 5) {
				return;
			}
		}

		this.cancel();
		this.timeoutId = setTimeout(this.func, ms);
		this.nextTime = nextTime;
	}

	run() {
		this.cancel();
		this.func();
	}

	cancel() {
		if (this.timeoutId) {
			clearTimeout(this.timeoutId);
		}

		this.timeoutId = null;
		this.nextTime = null;
	}
}
